import serviceTypes from '../../assets/serviceTypes';
import { FormattedMessage } from 'react-intl';

const serviceTypesColumns: any = serviceTypes?.map((serviceType) => ({
  label: <FormattedMessage id={`fleetadmin.serviceType.${serviceType}`} />,
  value: serviceType,
  disabled: false,
}));

const careColumns = [
  {
    label: 'Trip ID',
    value: 'code',
    textId: 'fleetadmin.care.table.tripid',
    disabled: true,
  },
  {
    label: 'Status',
    value: 'status',
    textId: 'fleetadmin.care.table.status',
    disabled: false,
  },
  {
    label: 'Plate',
    value: 'plate',
    textId: 'fleetadmin.care.table.plate',
    disabled: false,
  },
  {
    label: 'Fleet',
    value: 'fleetId',
    textId: 'fleetadmin.care.table.fleet',
    disabled: false,
  },
  {
    label: 'Area',
    value: 'areaId',
    textId: 'fleetadmin.care.table.area',
    disabled: false,
  },
  {
    label: 'Created at',
    value: 'createdAt',
    textId: 'fleetadmin.care.table.createdat',
    disabled: false,
  },
  {
    label: 'Accepted at',
    value: 'reservedAt',
    textId: 'fleetadmin.care.table.acceptedat',
    disabled: false,
  },
  {
    label: 'Start',
    value: 'tripStart',
    textId: 'fleetadmin.care.table.start',
    disabled: false,
  },
  {
    label: 'End',
    value: 'tripEnd',
    textId: 'fleetadmin.care.table.end',
    disabled: false,
  },
  {
    label: 'Duration',
    value: 'tripDuration',
    textId: 'fleetadmin.care.table.duration',
    disabled: false,
  },
  {
    label: 'Distance',
    value: 'tripDistance',
    textId: 'fleetadmin.care.table.distance',
    disabled: false,
  },
  {
    label: 'Service Hero',
    value: 'userReferralCode',
    textId: 'fleetadmin.care.table.servicehero',
    disabled: false,
  },
  {
    label: 'Brand',
    value: 'brandCode',
    textId: 'fleetadmin.care.table.brand',
    disabled: false,
  },
  {
    label: 'VIN',
    value: 'chassisNumber',
    textId: 'fleetadmin.care.table.vin',
    disabled: false,
  },
  {
    label: 'Service Count',
    value: 'serviceTypes',
    textId: 'fleetadmin.care.table.servicecount',
    disabled: false,
  },
  {
    label: 'Back by',
    value: 'backBy',
    textId: 'fleetadmin.care.table.backby',
    disabled: false,
  },
  {
    label: 'Pickup location',
    value: 'pickupLocation',
    textId: 'fleetadmin.care.table.pickuplocation',
    disabled: false,
  },
  ...serviceTypesColumns,
];

export const defaultSelectedCareColumns = careColumns.map(
  (careColumn) => careColumn.value
);

export default careColumns;
